<template>
  <div class="handleTechnicalDialogue">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="530px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="话术分类" prop="speechcraftClassifyId">
            <el-select
              style="width: 300px"
              v-model="formInline.speechcraftClassifyId"
              placeholder="请选择话术分类"
            >
              <el-option
                v-for="item in data"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题" prop="question">
            <el-input
              type="textarea"
              style="width: 360px"
              :rows="3"
              placeholder="请输入问题"
              v-model="formInline.question"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="对应话术" prop="answer">
            <el-input
              type="textarea"
              style="width: 360px"
              :rows="5"
              placeholder="请输入对应话术"
              v-model="formInline.answer"
              maxlength="800"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="排序号" prop="sortNum">
            <el-input
              v-model="formInline.sortNum"
              maxlength="5"
              style="width: 300px"
              @input="sortNumInput"
              placeholder="请输入排序号"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addCmsSpeechcraft,
  updateCmsSpeechcraft,
  getSpeechcraftClassifyListPage,
} from "@/api/marketingAdmin/technicalDialogue.js";
export default {
  data() {
    return {
      dialogTitle: "",
      dialogVisible: false,
      formInline: {
        speechcraftClassifyId: "",
        question: "",
        answer: "",
        sortNum: "",
      },
      rules: {
        speechcraftClassifyId: [
          { required: true, message: "请选择话术分类", trigger: "change" },
        ],
        question: [{ required: true, message: "请输入问题", trigger: "blur" }],
        answer: [
          { required: true, message: "请输入对应话术", trigger: "blur" },
        ],
        sortNum: [{ required: true, message: "请输入排序号", trigger: "blur" }],
      },
      status: "",
      data: [],
    };
  },
  methods: {
    // 话术分类列表
    async getSpeechcraftClassifyListPage() {
      const res = await getSpeechcraftClassifyListPage({ page: 1, limit: -1 });
      this.data = res.data?.records || [];
    },
    // 数字校验
    sortNumInput(payload) {
      this.$nextTick(() => {
        this.$set(this.formInline, "sortNum", payload.replace(/[^\d]/g, ""));
      });
    },
    // 初始化
    init(status, payload) {
      Object.assign(this.$data, this.$options.data());
      this.status = status;
      this.dialogTitle = status === "add" ? "新建招生话术" : "编辑招生话术";
      this.getSpeechcraftClassifyListPage();
      if (status === "alter") {
        Object.keys(this.formInline).forEach((item) => {
          this.formInline[item] = payload[item];
        });
        this.formInline.id = payload.id;
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          if (this.status === "add") {
            addCmsSpeechcraft({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          } else if (this.status === "alter") {
            updateCmsSpeechcraft({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          }
        }
      });
    },
  },
};
</script>